// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__H3Ak8","value":"styles_value__u3ieC","skeleton-animation":"styles_skeleton-animation__Ing3t"};